// extracted by mini-css-extract-plugin
export default {"wrapper":"DropdownSelect_wrapper__RCo7l","errorMessage":"DropdownSelect_errorMessage__QPxKB"};